import { handleActions } from 'redux-actions';
import * as Actions from '../../actions/';

const initialState = {
  data: [],
  pagination: {
    pageSize: 10,
    draw: 1,
    totalRows: 0,
    page: 0
  },
  criteria: []
};

const criteriaReducer = handleActions(
	{
		[Actions.fetchCriteriaSuccess]: (state, action) => {
			return {
				...state,
        data: action.payload.data,
        pagination: action.payload.pagination,
        criteria: action.payload.criteria,
        inProgress: action.payload.inProgress
			}
    },
    [Actions.fetchCriteriaInProgress]: (state, action) => {
			return {
				...state,
        inProgress: action.payload.inProgress
			}
		}
	},
	initialState
);

export default criteriaReducer;
